<template>
  <tela-component title="Relatório Dados Clientes">
    <v-card flat rounded="lg">
      <v-card-text>
        <v-row>
          <v-col>
            <selecionar-vendedor-relat />
            <v-checkbox
              label="Sócios"
              hide-details=""
              v-model="socios"
            ></v-checkbox>
            <v-checkbox
              label="Não Sócios"
              hide-details=""
              v-model="nsocios"
            ></v-checkbox>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-btn
              rounded
              block
              depressed
              color="info"
              @click="gerarRelatorio()"
              >Gerar Relatório</v-btn
            >
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </tela-component>
</template>

<script>
import { mapState } from "vuex";
import TelaComponent from "../tela/TelaComponent.vue";
import SelecionarVendedorRelat from "./SelecionarVendedorRelat.vue";
export default {
  components: { TelaComponent, SelecionarVendedorRelat },
  computed: {
    ...mapState("usuario", ["usuarioLogado"]),
    ...mapState("relatorios", ["vendedorSelecionado"]),
  },
  data: () => ({
    socios: true,
    nsocios: true,
  }),
  methods: {
    gerarRelatorio() {
      window.open(
        `${
          process.env.VUE_APP_BASE_URL
        }/nutricao-animal/relatorios/clientes?token=${
          this.usuarioLogado.token
        }&socios=${this.socios ? "S" : "N"}&nsocios=${
          this.nsocios ? "S" : "N"
        }&codvendedor=${this.vendedorSelecionado}`,
        "_blank"
      );
    },
  },
};
</script>

<style>
</style>